const initDomainsLinks = () => {
  const links = document.querySelectorAll('.domain-link');
  if(links){
    links.forEach(function(link){
      link.addEventListener('click', function(){
        window.location.href = link.dataset.go;
      });
    });
  }
}

export { initDomainsLinks }
